import React from "react"

// Utils
import { colors } from "utils/variables/"

// Libraries
import { useTranslation } from "gatsby-plugin-react-i18next"

// Components
import CaseStudyHero from "components/case-study-hero/"
import FeaturedImage from "./featured-image"

const Hero = () => {
  const { t } = useTranslation()

  return (
    <React.Fragment>
      <CaseStudyHero
        title={t(
          "Consolidating LymeMIND's brand and developing a dynamic website"
        )}
        details={[
          t("LymeMIND at Icahn School of Medicine in Mount Sinai"),
          t("New York, USA"),
          "2020",
        ]}
        tags={[
          t("Brand Story"),
          t("Brand Messaging"),
          t("Branding"),
          t("Website Design & Development"),
        ]}
        backgroundColor={colors.supernova}
        color={colors.midnight}
        bulletColor={colors.indiblue}
      />
      <FeaturedImage />
    </React.Fragment>
  )
}

export default Hero
